/* Copyright (c) 2018 Scaper */

export const HOMEOWNERS_PATH = "/homeowners";
